import React from "react";
import Meta from "./../components/Meta";
import Navbar from "../components/Navbar";

function NotFoundPage(props) {
  return (
    <>
      <Meta title="404" />
      <Navbar
        color="default"
        logo="https://drive.google.com/uc?export=view&id=1idL8ixbXPQ6cFrmYenBkUfmz2X9_MkFi"
        logoInverted="https://drive.google.com/uc?export=view&id=1FDW3ksZ8tqRXneFsRPHFN4Gor8X1kfEA"
      />
      <div
        style={{
          padding: "50px",
          width: "100%",
          textAlign: "center",
        }}
      >
        The page <code>{props.location.pathname}</code> could not be found
      </div>
    </>
  );
}

export default NotFoundPage;
